import { createRouter, createWebHistory } from 'vue-router'
import { ReviseMeta } from '@/util/meta'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 入口页面
    {
      path: '/',
      component: () => import('./views/yygw/index.vue'),
      meta: {
        title: '《仙境传说：破晓》官方网站-初心回归，好玩不累',
        keywords:
          'RO、仙境传说、巴风特、仙境传说破晓、破晓、MMO、仙境传说官网、仙境传说新作、ro破晓、初心者',
        description:
          '竖屏新RO，轻量化还原端游精髓，离线挂机秒追进度！横跨二十年的重逢！普隆德拉酒馆等你续杯~ ',
      },
    },
    {
      path: '/m',
      component: () => import('./views/yygw/index.vue'),
      meta: {
        title: '《仙境传说：破晓》官方网站-初心回归，好玩不累',
        keywords:
          'RO、仙境传说、巴风特、仙境传说破晓、破晓、MMO、仙境传说官网、仙境传说新作、ro破晓、初心者',
        description:
          '竖屏新RO，轻量化还原端游精髓，离线挂机秒追进度！横跨二十年的重逢！普隆德拉酒馆等你续杯~ ',
      },
    },
    // 官网新闻
    {
      path: '/news',
      component: () => import('./views/yygw/news.vue'),
      meta: {
        title: '《仙境传说：破晓》官方网站-初心回归，好玩不累',
        keywords:
          'RO、仙境传说、巴风特、仙境传说破晓、破晓、MMO、仙境传说官网、仙境传说新作、ro破晓、初心者',
        description:
          '竖屏新RO，轻量化还原端游精髓，离线挂机秒追进度！横跨二十年的重逢！普隆德拉酒馆等你续杯~ ',
      },
    },
    {
      path: '/news/m',
      component: () => import('./views/yygw/news.vue'),
      meta: {
        title: '《仙境传说：破晓》官方网站-初心回归，好玩不累',
        keywords:
          'RO、仙境传说、巴风特、仙境传说破晓、破晓、MMO、仙境传说官网、仙境传说新作、ro破晓、初心者',
        description:
          '竖屏新RO，轻量化还原端游精髓，离线挂机秒追进度！横跨二十年的重逢！普隆德拉酒馆等你续杯~ ',
      },
    },
    // 官网内容
    {
      path: '/content',
      component: () => import('./views/yygw/content.vue'),
      meta: {
        title: '《仙境传说：破晓》官方网站-初心回归，好玩不累',
        keywords:
          'RO、仙境传说、巴风特、仙境传说破晓、破晓、MMO、仙境传说官网、仙境传说新作、ro破晓、初心者',
        description:
          '竖屏新RO，轻量化还原端游精髓，离线挂机秒追进度！横跨二十年的重逢！普隆德拉酒馆等你续杯~ ',
      },
    },
    {
      path: '/content/m',
      component: () => import('./views/yygw/content.vue'),
      meta: {
        title: '《仙境传说：破晓》官方网站-初心回归，好玩不累',
        keywords:
          'RO、仙境传说、巴风特、仙境传说破晓、破晓、MMO、仙境传说官网、仙境传说新作、ro破晓、初心者',
        description:
          '竖屏新RO，轻量化还原端游精髓，离线挂机秒追进度！横跨二十年的重逢！普隆德拉酒馆等你续杯~ ',
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  // 路由发生变化改变description和keyword
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description)
  const userAgent = navigator.userAgent.toLowerCase()
  const isMobile = /iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(userAgent)

  if (isMobile) {
    if (to.path == '/') {
      next({ path: '/m', query: to.query })
    } else if (to.path == '/home') {
      next({ path: '/home/m', query: to.query })
    } else {
      next()
    }
  } else {
    if (to.path == '/m') {
      next({ path: '/', query: to.query })
    } else if (to.path == '/home/m') {
      next({ path: '/home', query: to.query })
    } else {
      next()
    }
  }
  // next()
})

export default router
